module.exports = __webpack_public_path__ + "img/rod_of_atos.36139596.png";